var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "EventFlow" }, [
    _c(
      "ul",
      {
        directives: [
          {
            name: "infinite-scroll",
            rawName: "v-infinite-scroll",
            value: _vm.init,
            expression: "init",
          },
        ],
      },
      _vm._l(_vm.initList, function (item) {
        return _c("li", { key: item.guid }, [
          _c("div", { staticClass: "time" }, [
            _vm._v(_vm._s(_vm.formatTime(item.localTime))),
          ]),
          _vm._m(0, true),
          _c("div", { staticClass: "event-info" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.getEventTypeText(item.serviceNumber)) +
                " " +
                _vm._s(_vm.getStatusText(item.status)) +
                " " +
                _vm._s(_vm.getDetailsText(item)) +
                "\n      "
            ),
          ]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "_icon" }, [
      _c("i", { staticClass: "spot" }),
      _c("i", { staticClass: "line" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }